import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import {
  MdFolder,
  MdInsertDriveFile,
  MdMoreVert,
  MdDelete,
  MdModeEditOutline,
} from "react-icons/md";
import { capitalizeFirstLetter } from "../../helpers";

const DocumentCards = ({
  currentItems,
  handleFolderClick,
  formatDate,
  handleDelete,
  handleEdit
}) => {
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);

  const toggleMenu = (e, itemId) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenMenuId((prev) => (prev === itemId ? null : itemId));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-4">
      {currentItems.map((item) => {
        const isFolder = item.type === "folder";

        return (
          <DocCard
            key={item.id}
            className={isFolder ? "cursor-pointer hover:bg-gray-50" : ""}
            onClick={() => isFolder && handleFolderClick(item)}
          >
            <div className="flex items-start justify-between w-full mb-2">
              <div className="flex items-center gap-2">
                {isFolder ? (
                  <MdFolder size={24} className="text-yellow-500" />
                ) : (
                  <MdInsertDriveFile
                    size={24}
                    className="text-blue-500"
                  />
                )}

                <span className="text-sm font-semibold text-gray-800">
                  {capitalizeFirstLetter(
                    isFolder ? item.name : item.title
                  )}
                </span>
              </div>

              <div
                className="relative"
                ref={openMenuId === item.id ? menuRef : null}
              >
                <button
                  onClick={(e) => toggleMenu(e, item.id)}
                  className="p-1 rounded-full hover:bg-gray-100"
                >
                  <MdMoreVert size={20} />
                </button>

                {openMenuId === item.id && (
                  <div className="absolute right-0 mt-1 w-max rounded-lg border bg-white shadow-lg z-20">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleEdit(item);
                          setOpenMenuId(null);
                        }}
                        // className="flex w-full items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100"
                        className="flex w-full items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
                      >
                        <MdModeEditOutline size={17} />
                        {isFolder ? "Rename Folder" : "Rename File"}
                      </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        handleDelete(item);
                        setOpenMenuId(null);
                      }}
                      disabled={isFolder && item.contentCount > 0}
                      className="flex w-full items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <MdDelete size={17} />
                      {isFolder ? "Delete Folder" : "Delete File"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {item.createdAt && (
              <span className="text-xs text-gray-400 mt-1">
                {formatDate(item.createdAt)}
              </span>
            )}

            {!isFolder ? (
              <a
                href={item.fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 text-sm font-medium text-primary-color hover:underline"
                onClick={(e) => e.stopPropagation()}
              >
                View / Download
              </a>
            ) : (
              <span className="mt-3 text-xs text-gray-500">
                {item.contentCount || 0} item(s)
              </span>
            )}
          </DocCard>
        );
      })}
    </div>
  );
};

const DocCard = tw.div`
flex flex-col items-start
bg-white border border-gray-200
p-4 rounded-xl shadow-sm
hover:shadow-md transition-all duration-200
`;

export default DocumentCards;
